import styled from 'styled-components';

const S = {};

const ellipsis = `
        overflow: hidden;
        text-overflow: ellipsis;
    `

S.WalletTransactionsItem = styled.div`
display: flex;
gap: 0.08rem;
border-bottom: .08rem solid #898989;

&.open{
    border: none;
}

& > div {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    height: 2.87rem;
	font-size: 0.83rem;
	font-weight: 500;
    text-align: center;
	color: #000;

	&.wallet-status {
        position: relative;

		&.red{
		    color: #CA2717;
		}
		&.green{
		    color: #019A44;
		}
        &.blue{
            color: #0047B9;
        } 
        & > span {
            padding: 0 1rem;
            ${ellipsis}
        }
	}

	&.wallet-type {
        justify-content: start;

        & > span {
            ${ellipsis}
        }
	}

    
}
`;

S.WalletTransactionsItemDetails = styled.div`
    overflow: hidden;
    max-height: 0;
    background-color: #A5A5A5;
    font-size: 0.9rem;
    color: #fff;
    transition-property: max-height;
    transition-duration: 0.6s;

    ${({isOpen}) => isOpen == true && 'max-height: 15.62rem;'}

    & > div {
        display: flex;
        flex-direction: column;
        gap: 0.3rem;
        padding: 0.86rem 1.25rem;
    }
`

S.OpenDetailsIcon = styled.img`
    position: absolute;
    right: 0.3rem;
    height: 0.81rem;
    width: 0.81rem;
    transform: rotate(-90deg);
    transition-property: transform;
    transition-duration: 0.3s;

    ${({isOpen}) => isOpen == true && 'transform: rotate(0);'};

    path {
        fill: #A5A5A5;
    }
`

S.TypeIcon = styled.img`
    flex-shrink: 0;
    margin: 0 0.3rem 0 5%;
    width: 0.86rem;
    height: 0.86rem;
`

export default S;